import React from 'react';
import { ReactComponent as MainBoardImage } from 'assets/images/dashboard/main-board.svg';
import defaultLocales from 'globals/locales/default';
import { useRole } from 'globals/hooks/useRole';
import { UserRole } from 'globals/types';

import FsBody from 'ui-elements/typography/FsBody';
import FsHeaderLarge from 'ui-elements/typography/FsHeaderLarge';
import {
  ImageWrapper,
  InfoWrapper,
  MainBoardBox,
} from './MainBoard.style-elements';

const {
  mainBoard: { title, description, titleAccountant, descriptionAccountant },
} = defaultLocales.welcomeDashboardPage;

const MainBoard: React.FC = () => {
  const isAccountant = useRole(UserRole.ACCOUNTANT);
  return (
    <MainBoardBox>
      <ImageWrapper>
        <MainBoardImage />
      </ImageWrapper>
      <InfoWrapper>
        <FsHeaderLarge>{isAccountant ? titleAccountant : title}</FsHeaderLarge>
        <FsBody>{isAccountant ? descriptionAccountant : description}</FsBody>
      </InfoWrapper>
    </MainBoardBox>
  );
};

export default MainBoard;
